export const getHasHavePlural = count => (count > 1 ? 'have' : 'has');
export const getPluralSuffix = count => (count === 1 ? '' : 's');
